export default __webpack_public_path__ + "static/media/banner3.e576671b.svg";